import './index.scss';
import 'images/modals/man-computer.svg';

export default class ForumModal {
  constructor(context) {
    this.$context = $(context);
    this.$postBtn = $('.js-post-btn', this.$context);
    this.$continueBtn = $('.q-forum-modal-continue', this.$context);

    this.questionId = this.$context.data('questionId');
    this.playgroundUrl = this.$context.data('playgroundUrl');
    this.currentStudyGuideName = this.$context.data('currentStudyGuideName');
    this.bind();
  }

  bind() {
    this.$continueBtn.on('click', () => {
      this.trackForumModalDoubtCreated('continue in questions');
    });

    this.$postBtn.on('click', async () => {
      try {
        this.$postBtn.prop('disabled', true);
        await this.trackForumModalDoubtCreated('see question in forum');

        if (this.playgroundUrl) {
          Turbolinks.visit(this.playgroundUrl);
        }
      } catch (error) {
        Rollbar.error('Error tracking forum modal event', error);
      } finally {
        this.$postBtn.prop('disabled', false);
      }
    });
  }

  async trackForumModalDoubtCreated(actionChosen) {
    return new Promise((resolve, reject) => {
      try {
        UserTracker.emit('event', {
          eventName: 'forum modal doubt created',
          data: {
            'action chosen': actionChosen,
            'course name': this.currentStudyGuideName,
            question_id: this.questionId,
            'source platform': 'odin',
            'source project': gon.source_project
          }
        });
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }
}
